// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4468":"2394b82a","4817":"e790e880","5744":"33b69ede","8105":"0b8f916d","8410":"2394b82a","9246":"2394b82a"}[chunkId] + ".chunk.css";
};